const formatDateEs = (value) => {
  if (!value) return ''
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return `${value}`
  return date.toLocaleString('es-UY', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

const normalizeCardType = (cardType) => `${cardType || ''}`.trim().toUpperCase()
const cardTypeLabelByCode = {
  TS: 'Tarjeta de Seguridad',
  TO: 'Tarjeta de Órden y Limpieza',
  TM: 'Tarjeta de Mantenimiento',
  TQ: 'Tarjeta de Calidad',
}

const body = (
  cardTitle,
  cardDescription,
  creationDate,
  creatorName,
  area,
  cardNumber,
  photoUrl,
  videoUrl,
  cardLink,
  isAssignment = false
) => {
  const intro = isAssignment
    ? `Le informamos que se le ha asignado como responsable la siguiente ${cardTitle}. A continuación, se presentan los detalles:`
    : `Le informamos que se ha generado una nueva ${cardTitle}. A continuación, se presentan los detalles:`
  return `
${intro}

- **Título:** ${cardTitle}
- **N° tarjeta:** ${cardNumber || 'N/D'}
- **Descripción:** ${cardDescription}
- **Fecha:** ${formatDateEs(creationDate)}
- **Generado por:** ${creatorName}
- **Área:** ${area || 'Sin ubicación'}
${photoUrl ? `- **Foto:** ${photoUrl}` : '- **Foto:** Sin adjunto'}
${videoUrl ? `- **Video:** ${videoUrl}` : '- **Video:** Sin adjunto'}
${cardLink ? `- **Enlace:** ${cardLink}` : ''}

Le recomendamos acceder al sistema para más detalles.`
}

const bodyHtml = (
  cardTitle,
  cardDescription,
  creationDate,
  creatorName,
  area,
  cardNumber,
  photoUrl,
  videoUrl,
  cardLink,
  isAssignment = false
) => {
  const heading = isAssignment ? 'Tarjeta asignada' : `Nueva ${cardTitle}`
  const intro = isAssignment
    ? `Le informamos que se le ha asignado como responsable la siguiente ${cardTitle}. A continuación se presentan los detalles:`
    : `Le informamos que se ha generado una nueva ${cardTitle}. A continuación se presentan los detalles:`
  return `
<div style="background:#f4f6f8;padding:24px 12px;font-family:Arial,sans-serif;">
  <div style="max-width:640px;margin:0 auto;background:#ffffff;border:1px solid #d9e1ea;border-radius:10px;overflow:hidden;">
    <div style="padding:14px 20px;background:#ffffff;border-bottom:1px solid #d9e1ea;">
      <table role="presentation" style="width:100%;border-collapse:collapse;">
        <tr>
          <td style="vertical-align:middle;">
            <h2 style="margin:0;font-size:18px;line-height:1.3;color:#111317;">${heading}</h2>
          </td>
          <td style="text-align:right;vertical-align:middle;">
            <img src="https://ccu.whitebear.io/logo.png" alt="CCU" style="height:24px;display:inline-block;" />
          </td>
        </tr>
      </table>
    </div>
    <div style="padding:20px;color:#111317;">
      <p style="margin:0 0 14px 0;font-size:14px;line-height:1.5;">
        ${intro}
      </p>
      <table style="width:100%;border-collapse:collapse;font-size:14px;">
        <tr><td style="padding:8px 0;color:#5f6772;"><strong>Título</strong></td><td style="padding:8px 0;">${cardTitle}</td></tr>
      <tr><td style="padding:8px 0;color:#5f6772;"><strong>N° tarjeta</strong></td><td style="padding:8px 0;">${cardNumber || 'N/D'}</td></tr>
                <tr><td style="padding:8px 0;color:#5f6772;width:170px;"><strong>Descripción</strong></td><td style="padding:8px 0;">${cardDescription}</td></tr>
        <tr><td style="padding:8px 0;color:#5f6772;"><strong>Fecha</strong></td><td style="padding:8px 0;">${formatDateEs(creationDate)}</td></tr>
        <tr><td style="padding:8px 0;color:#5f6772;"><strong>Generado por</strong></td><td style="padding:8px 0;">${creatorName}</td></tr>
        <tr><td style="padding:8px 0;color:#5f6772;"><strong>Área</strong></td><td style="padding:8px 0;">${area || 'Sin ubicación'}</td></tr>
        <tr><td style="padding:8px 0;color:#5f6772;"><strong>Foto</strong></td><td style="padding:8px 0;">${
          photoUrl
            ? `<a href="${photoUrl}" target="_blank" rel="noreferrer">Ver foto</a>`
            : 'Sin adjunto'
        }</td></tr>
        <tr><td style="padding:8px 0;color:#5f6772;"><strong>Video</strong></td><td style="padding:8px 0;">${
          videoUrl
            ? `<a href="${videoUrl}" target="_blank" rel="noreferrer">Ver video</a>`
            : 'Sin adjunto'
        }</td></tr>
      </table>
      ${
        cardLink
          ? `<div style="margin-top:18px;">
              <a href="${cardLink}" target="_blank" rel="noreferrer"
                style="display:inline-block;background:#58ab30;color:#ffffff;text-decoration:none;padding:10px 14px;border-radius:20px;font-size:13px;font-weight:700;">
                Abrir tarjeta en la app
              </a>
            </div>`
          : ''
      }
      <p style="margin:18px 0 0 0;font-size:13px;color:#5f6772;">
        Le recomendamos acceder al sistema para más detalles.
      </p>
    </div>
  </div>
</div>`
}

const mailNotificationsMessage = (
  cardType,
  cardDescription,
  creationDate,
  creatorName,
  area,
  cardNumber,
  photoUrl,
  videoUrl,
  cardLink,
  options = {}
) => {
  const normalizedCardType = normalizeCardType(cardType)
  const isAssignment = options.intent === 'assignment'
  const subject = isAssignment
    ? `Tarjeta asignada - ${cardNumber}`
    : `Nueva Tarjeta generada - ${cardNumber}`
  let text
  let html
  switch (normalizedCardType) {
    case 'TS':
      text = body(
        'Tarjeta de Seguridad',
        cardDescription,
        creationDate,
        creatorName,
        area,
        cardNumber,
        photoUrl,
        videoUrl,
        cardLink,
        isAssignment
      )
      html = bodyHtml(
        'Tarjeta de Seguridad',
        cardDescription,
        creationDate,
        creatorName,
        area,
        cardNumber,
        photoUrl,
        videoUrl,
        cardLink,
        isAssignment
      )
      return {
        subject,
        text,
        html,
      }
    case 'TO':
      text = body(
        'Tarjeta de Órden y Limpieza',
        cardDescription,
        creationDate,
        creatorName,
        area,
        cardNumber,
        photoUrl,
        videoUrl,
        cardLink,
        isAssignment
      )
      html = bodyHtml(
        'Tarjeta de Órden y Limpieza',
        cardDescription,
        creationDate,
        creatorName,
        area,
        cardNumber,
        photoUrl,
        videoUrl,
        cardLink,
        isAssignment
      )
      return {
        subject,
        text,
        html,
      }
    case 'TM':
      text = body(
        'Tarjeta de Mantenimiento',
        cardDescription,
        creationDate,
        creatorName,
        area,
        cardNumber,
        photoUrl,
        videoUrl,
        cardLink,
        isAssignment
      )
      html = bodyHtml(
        'Tarjeta de Mantenimiento',
        cardDescription,
        creationDate,
        creatorName,
        area,
        cardNumber,
        photoUrl,
        videoUrl,
        cardLink,
        isAssignment
      )
      return {
        subject,
        text,
        html,
      }
    case 'TQ':
      text = body(
        'Tarjeta de Calidad',
        cardDescription,
        creationDate,
        creatorName,
        area,
        cardNumber,
        photoUrl,
        videoUrl,
        cardLink,
        isAssignment
      )
      html = bodyHtml(
        'Tarjeta de Calidad',
        cardDescription,
        creationDate,
        creatorName,
        area,
        cardNumber,
        photoUrl,
        videoUrl,
        cardLink,
        isAssignment
      )
      return {
        subject,
        text,
        html,
      }
  }
}

export const cardStatusChangeNotificationMessage = (
  cardType,
  cardNumber,
  newStatusLabel,
  updaterName,
  updatedDate,
  cardLink
) => {
  const normalizedCardType = normalizeCardType(cardType)
  const cardTypeLabel = cardTypeLabelByCode[normalizedCardType] || 'Tarjeta'
  const subject = `Actualización de estado - ${cardNumber || normalizedCardType}`
  const formattedDate = formatDateEs(updatedDate)
  const text = `La ${cardTypeLabel} ${cardNumber || ''} cambió de estado a "${newStatusLabel}".

- Estado actual: ${newStatusLabel}
- Fecha de actualización: ${formattedDate}
- Actualizado por: ${updaterName}
${cardLink ? `- Enlace: ${cardLink}` : ''}
`
  const html = `
<div style="background:#f4f6f8;padding:24px 12px;font-family:Arial,sans-serif;">
  <div style="max-width:640px;margin:0 auto;background:#ffffff;border:1px solid #d9e1ea;border-radius:10px;overflow:hidden;">
    <div style="padding:14px 20px;background:#ffffff;border-bottom:1px solid #d9e1ea;">
      <table role="presentation" style="width:100%;border-collapse:collapse;">
        <tr>
          <td style="vertical-align:middle;">
            <h2 style="margin:0;font-size:18px;line-height:1.3;color:#111317;">Tarjeta actualizada</h2>
          </td>
          <td style="text-align:right;vertical-align:middle;">
            <img src="https://ccu.whitebear.io/logo.png" alt="CCU" style="height:24px;display:inline-block;" />
          </td>
        </tr>
      </table>
    </div>
    <div style="padding:20px;color:#111317;">
      <p style="margin:0 0 14px 0;font-size:14px;line-height:1.5;">
        La ${cardTypeLabel} <strong>${cardNumber || ''}</strong> cambió de estado a <strong>${newStatusLabel}</strong>.
      </p>
      <table style="width:100%;border-collapse:collapse;font-size:14px;">
        <tr><td style="padding:8px 0;color:#5f6772;width:170px;"><strong>Estado actual</strong></td><td style="padding:8px 0;">${newStatusLabel}</td></tr>
        <tr><td style="padding:8px 0;color:#5f6772;"><strong>Fecha de actualización</strong></td><td style="padding:8px 0;">${formattedDate}</td></tr>
        <tr><td style="padding:8px 0;color:#5f6772;"><strong>Actualizado por</strong></td><td style="padding:8px 0;">${updaterName}</td></tr>
      </table>
      ${
        cardLink
          ? `<div style="margin-top:18px;">
              <a href="${cardLink}" target="_blank" rel="noreferrer"
                style="display:inline-block;background:#58ab30;color:#ffffff;text-decoration:none;padding:10px 14px;border-radius:20px;font-size:13px;font-weight:700;">
                Ver tarjeta en la app
              </a>
            </div>`
          : ''
      }
    </div>
  </div>
</div>`

  return {
    subject,
    text,
    html,
  }
}

export const cardResponsibleChangeNotificationMessage = (
  cardType,
  cardNumber,
  newResponsibleName,
  updaterName,
  updatedDate,
  cardLink
) => {
  const normalizedCardType = normalizeCardType(cardType)
  const cardTypeLabel = cardTypeLabelByCode[normalizedCardType] || 'Tarjeta'
  const subject = `Tarjeta reasignada - ${cardNumber || normalizedCardType}`
  const formattedDate = formatDateEs(updatedDate)
  const text = `La ${cardTypeLabel} ${cardNumber || ''} fue reasignada.

- Nuevo responsable: ${newResponsibleName}
- Reasignada por: ${updaterName}
- Fecha de reasignación: ${formattedDate}
${cardLink ? `- Enlace: ${cardLink}` : ''}
`
  const html = `
<div style="background:#f4f6f8;padding:24px 12px;font-family:Arial,sans-serif;">
  <div style="max-width:640px;margin:0 auto;background:#ffffff;border:1px solid #d9e1ea;border-radius:10px;overflow:hidden;">
    <div style="padding:14px 20px;background:#ffffff;border-bottom:1px solid #d9e1ea;">
      <table role="presentation" style="width:100%;border-collapse:collapse;">
        <tr>
          <td style="vertical-align:middle;">
            <h2 style="margin:0;font-size:18px;line-height:1.3;color:#111317;">Responsable reasignado</h2>
          </td>
          <td style="text-align:right;vertical-align:middle;">
            <img src="https://ccu.whitebear.io/logo.png" alt="CCU" style="height:24px;display:inline-block;" />
          </td>
        </tr>
      </table>
    </div>
    <div style="padding:20px;color:#111317;">
      <p style="margin:0 0 14px 0;font-size:14px;line-height:1.5;">
        La ${cardTypeLabel} <strong>${cardNumber || ''}</strong> fue reasignada a <strong>${newResponsibleName}</strong>.
      </p>
      <table style="width:100%;border-collapse:collapse;font-size:14px;">
        <tr><td style="padding:8px 0;color:#5f6772;width:170px;"><strong>Nuevo responsable</strong></td><td style="padding:8px 0;">${newResponsibleName}</td></tr>
        <tr><td style="padding:8px 0;color:#5f6772;"><strong>Reasignada por</strong></td><td style="padding:8px 0;">${updaterName}</td></tr>
        <tr><td style="padding:8px 0;color:#5f6772;"><strong>Fecha de reasignación</strong></td><td style="padding:8px 0;">${formattedDate}</td></tr>
      </table>
      ${
        cardLink
          ? `<div style="margin-top:18px;">
              <a href="${cardLink}" target="_blank" rel="noreferrer"
                style="display:inline-block;background:#58ab30;color:#ffffff;text-decoration:none;padding:10px 14px;border-radius:20px;font-size:13px;font-weight:700;">
                Ver tarjeta en la app
              </a>
            </div>`
          : ''
      }
    </div>
  </div>
</div>`

  return {
    subject,
    text,
    html,
  }
}

export default mailNotificationsMessage
